/**
 * WCAG 2.1 contrast helpers. Used by the admin Theme editor to block saving a
 * brand palette whose text/surface pairing would be unreadable (AA = 4.5:1 for
 * normal text), honoring docs/design-context.md's AA mandate.
 */

function channel(c: number): number {
  const s = c / 255
  return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4
}

function relativeLuminance(hex: string): number {
  const m = /^#?([0-9a-fA-F]{6})$/.exec(hex)
  const n = parseInt(m ? m[1]! : '000000', 16)
  const r = (n >> 16) & 0xff
  const g = (n >> 8) & 0xff
  const b = n & 0xff
  return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b)
}

/** Contrast ratio between two hex colours (1..21), order-independent. */
export function contrastRatio(a: string, b: string): number {
  const la = relativeLuminance(a)
  const lb = relativeLuminance(b)
  const lighter = Math.max(la, lb)
  const darker = Math.min(la, lb)
  return (lighter + 0.05) / (darker + 0.05)
}

/** True if `fg` on `bg` meets WCAG AA for normal text (>= 4.5:1). */
export function meetsAA(fg: string, bg: string): boolean {
  return contrastRatio(fg, bg) >= 4.5
}
